import { defineComponent } from 'vue';
export default defineComponent({
    name: 'kontakt-info',
    inject: ['supportDelay'],
    data() {
        return {
            possiblyLate: this.supportDelay,
        };
    },
});
